export const applyDefaultApiAuthorization = (url, options = {}, staffToken = '') => {
  const isApiRequest = typeof url === 'string' && url.includes('/api/');
  const isCustomerAppRequest = typeof url === 'string' && url.includes('/api/ucp/');
  if (!staffToken || !isApiRequest || isCustomerAppRequest) return options;

  const headers = new Headers(options.headers || {});
  if (headers.has('Authorization')) return options;

  headers.set('Authorization', `Bearer ${staffToken}`);
  return { ...options, headers };
};

export const applyFinanceAuthorization = (options = {}, token = '') => {
  const headers = new Headers(options.headers || {});
  const jwtLike = typeof token === 'string' && token.split('.').length === 3;
  if (jwtLike && !headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`);
  // Do not let a legacy/non-JWT localStorage token override the authenticated
  // HttpOnly cookie used by Finance/Admin payment endpoints.
  if (!jwtLike && !headers.has('Authorization')) headers.delete('Authorization');
  return { ...options, credentials: 'same-origin', headers };
};
